import { Result } from 'antd';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import Lang from './Lang';

const Failure = observer(() => (
  <div className="not_found_wrp">
    <div className="not_found">
      <Result
        status="error"
        title={Lang({ str: 'paymentStatusFailed', section: 'default' })}
        // subTitle="Please try again later"
        extra={[
          <Link className="main_page_but" key={'failure'} to={'/'}>
            {Lang({ str: 'newchall', section: 'default' })}
          </Link>,
        ]}
      />
    </div>
  </div>
));

export default Failure;
